import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { Dispatch } from "../store";
import Topbar from "./Topbar";

const mapDispatchToProps = (dispatch: Dispatch) => ({
  signout: dispatch.auth.signout,
});

type Props = ReturnType<typeof mapDispatchToProps>;

class Container extends React.Component<
  Props & StyledComponentProps & RouteComponentProps
> {
  public render() {
    const { classes } = this.props;
    const currentPath = this.props.location.pathname;

    return (
      <div className={classes && classes.root}>
        <Topbar currentPath={currentPath} onLogout={this.props.signout} />
        <main className={classes && classes.content}>
          <div className={classes && classes.appBarSpacer} />
          {this.props.children}
        </main>
      </div>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(3),
  },
  root: {
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
});

export default withRouter(
  connect(undefined, mapDispatchToProps)(withStyles(styles)(Container))
);



// WEBPACK FOOTER //
// ./src/components/Container.tsx